import type { PaletteOptions } from "@mui/material/styles";

export const colors = {
  // ACTIVE: Used to represent something that is active or has been selected
  activeBackground: "#67B2FF",
  activeBackgroundHover: "#4A94E0",

  // Legacy colors
  transparentBlack: "rgba(0,0,0,0.5)",
  grayDark: "#262626",
  grayMediumDark: "#444444",
  grayMedium: "#C8C5BC",
  grayLight: "#F5F2EA",
  grayLighter: "#FAF9F5",

  aqua: "#3fb0a3",
  yellow: "#FFDF6D",

  // Component styling colors
  borderColor: "#d1d5dc",
  boxShadowColor: "#d1d5dc",
  secondaryBackground: "#F5F2EA",
};

export const paletteOptions = {
  primary: {
    main: "#04299E",
    light: "#67B2FF",
    dark: "#031F78",
    contrastText: "#ffffff",
  },
  secondary: {
    main: colors.grayMedium,
    light: colors.grayLight,
    dark: colors.grayMediumDark,
  },
  success: {
    main: "#1d9955",
    light: "#cce6d8",
    dark: "#1e7344",
  },
  warning: {
    main: "#856404",
    light: "#fff3cd",
    dark: "#533f03",
  },
  error: {
    main: "#C3272F",
    light: "#ffe8e8",
    dark: "#8c2020",
  },
  text: {
    primary: "#262626",
  },
  common: {
    white: "white",
    black: "black",
  },
  dream: {
    ...colors,
  },
} satisfies PaletteOptions;
